
import BForm from 'Src/js/components/blain-form/BForm.vue';
import BSelect from 'Src/js/components/blain-form/BSelect.vue';
import bugsnagClient from 'JS/global/bugsnag';
import Icon from 'Src/js/components/Icon.vue';
import LinkButton from 'Src/js/components/LinkButton.vue';
import StepWrapper from './StepWrapper.vue';
import TransitionExpand from 'Src/js/components/transitions/TransitionExpand.vue';
import VehicleAttributeSelector from './form/VehicleAttributeSelector.vue';
import WithImmutableObjectValue from 'JS/mixins/WithImmutableObjectValue';
import { Component, Inject, Mixins, Prop } from 'vue-property-decorator';
import { delay } from 'JS/utilities/promise';
import { TireSizeStep as ITireSizeStep } from '../types/steps';
import { IVehicleLookupService } from 'Src/js/services/automotive/VehicleLookupService';

@Component({
	name: 'TireSizeStep',
	components: {
		BForm,
		BSelect,
		StepWrapper,
		LinkButton,
		TransitionExpand,
		VehicleAttributeSelector,
		Icon,
	}
})
class TireSizeStep extends Mixins(WithImmutableObjectValue<ITireSizeStep['data']>(() => ({ size: null, availableSizes: null }))) {
	@Inject('VehicleLookupService')
	_vehicleLookupService: IVehicleLookupService;

	@Prop({ type: String, required: true })
	year: string;

	@Prop({ type: String, required: true })
	make: string;

	@Prop({ type: String, required: true })
	model: string;

	@Prop({ type: [String, Boolean], required: true })
	trim: string | false;

	@Prop({ type: Boolean })
	loading: boolean;

	loadingState: 'loading' | 'error' | 'idle' = 'idle';

	showTireDiagram: boolean = false;

	get canContinue() {
		return !!this.size;
	}

	async mounted() {
		if (this.availableSizes?.length) {
			return;
		}

		try {
			this.loadingState = 'loading';
			this.availableSizes = await delay(this._vehicleLookupService.getTireSizes(this.year, this.make, this.model, this.trim), 750);
			this.loadingState = 'idle';
		} catch (e) {
			bugsnagClient.notify(e);
			this.loadingState = 'error';
		}
	}
}

export default TireSizeStep;
